import { useApiQueryClient, useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dist/clients/dashboard/v20240730'
import {
  SettingsFormControl,
  TextInputField
} from '@sequencehq/core-components'
import { useForm } from '@sequencehq/utils'
import { isEmailsList } from '@sequencehq/validation'
import { useNotifications } from 'lib/hooks/useNotifications'

export const MerchantAlertSettings = (props: {
  id: string
  alertEmail: string[]
}) => {
  const { displayNotification } = useNotifications()

  const queryClient = useApiQueryClient()

  const { fields, queries } = useForm({
    value: {
      alertEmail: props.alertEmail
    },
    showValidationErrors: true,
    fieldConfiguration: [
      {
        property: 'alertEmail',
        validation: [isEmailsList({ permitEmpty: false })]
      }
    ]
  })

  const accountSettingsMutator = useMutation(
    dashboard20240730Client.putSequenceAccount,
    {
      onSettled: () => {
        queryClient.invalidateQueries({
          queryKey: dashboard20240730Client.getSequenceAccount.queryKey
        })
      }
    }
  )

  return (
    <SettingsFormControl
      label="Alert email"
      helper="Provide an email address for when something goes wrong"
      htmlFor="alert-email"
    >
      <TextInputField
        placeholder="hello@example.com"
        height="32px"
        disabled={accountSettingsMutator.isPending}
        width="180px"
        type="email"
        styles={{ wrapper: { marginBottom: 0 } }}
        id="alert-email"
        value={fields.alertEmail.value.join(',')}
        onChange={e => fields.alertEmail.onChange(e.target.value.split(','))}
        validationErrors={fields.alertEmail.validationErrors}
        onBlur={() => {
          const alertEmail = queries.formData.alertEmail

          if (fields.alertEmail.validationErrors.length > 0) {
            return
          }

          accountSettingsMutator.mutate(
            {
              id: props.id,
              alertEmailAddresses: alertEmail
            },
            {
              onSuccess: () => {
                displayNotification(`Alert email updated.`)
              },
              onError: () => {
                displayNotification(`Alert email update failed.`)
              }
            }
          )
        }}
      />
    </SettingsFormControl>
  )
}
